import ErrorComponent from './ErrorComponent'

export default ErrorComponent
